const genres = {
  _28: "Action",
  _12: "Adventure",
  _16: "Animation",
  _35: "Comedy",
  _80: "Crime",
  _99: "Documentary",
  _18: "Drama",
  _10751: "Family",
  _14: "Fantasy",
  _36: "History",
  _27: "Horror",
  _10402: "Music",
  _9648: "Mystery",
  _878: "Romance",
  _10749: "Science Fiction",
  _10770: "TV Movie",
  _53: "Thriller",
  _10752: "War",
  _37: "Western",
};

export default genres;
